import React, { useEffect, useRef, useState } from 'react';
import { Form, Input } from 'antd';
import { AlignLeftOutlined, InfoCircleOutlined } from '@ant-design/icons';
import ReactDOM from 'react-dom';
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

export default (formPlugin, namespace) => {
    return {
        Renderer: (props) => {

            let containerRef = useRef(null)
            const [listField, setlistField] = useState(null)
            useEffect(() => {
                setlistField(props.pluginConfig.getListField(containerRef.current))
            }, [])

            if (props.remove) {
                formPlugin.onAddFormPlugin(props, props.nodeId, props.pluginConfig.id)
            }

            if ((props.isPreviewMode || props.readOnly) && !props.data.fieldKey) {
                return null
            }

            const { data } = props

            let rules = [{ required: data.required || false, message: t`Ce champ est obligatoire` }]

            let tooltip = null
            if (data.tooltip) {
                tooltip = {
                    title: data.tooltip,
                    icon: <InfoCircleOutlined />,
                }
            }

            var inputStyle = {}

            if (data.height) {
                inputStyle.height = data.height
            }

            const listFieldProps = listField ? listField : null
            const finalName = "[TEXT]_" + data.fieldKey

            return (
                <div ref={(ref) => containerRef.current = ref}>
                    <Form.Item
                        {...listFieldProps}
                        label={<Trans>{(data.label || "Question")} :</Trans>}
                        name={listField ? [listField.name, finalName].flat() : finalName}
                        rules={rules}
                        tooltip={tooltip}
                    >
                        <Input.TextArea style={inputStyle} placeholder={data.placeholder} />
                    </Form.Item>
                </div>
            )
        },
        namespace: namespace,
        id: 'form-textarea' + namespace,
        title: t`Champ long`,
        description: t`Élément de formulaire utilisable.`,
        icon: <AlignLeftOutlined />,
        iconColor: "#F39C12",
        version: 1,
        getListField: (containerRef) => {
            const listField = ReactDOM.findDOMNode(containerRef)?.closest(".form-field")?.dataset.field
            if (listField) {
                return JSON.parse(listField)
            }
            return null
        },
        controls: {
            type: 'autoform',
            schema: {
                properties: {
                    required: {
                        type: 'boolean',
                        uniforms: {
                            label: t`Obligatoire`,
                        }
                    },
                    fieldKey: {
                        type: 'string',
                        uniforms: {
                            required: true,
                            label: t`Identifiant`,
                            placeholder: t`Identifiant du Champ`,
                        }
                    },
                    label: {
                        type: 'string',
                        uniforms: {
                            required: true,
                            label: t`Étiquette`,
                            placeholder: t`Libellé`,
                        }
                    },
                    placeholder: {
                        type: 'string',
                        uniforms: {
                            label: t`Sous-Étiquette`,
                            placeholder: t`Sous-Étiquette`,
                        }
                    },

                    tooltip: {
                        type: 'string',
                        uniforms: {
                            label: t`Message d'aide`,
                            placeholder: t`Message d'aide`,
                            multiline: true,
                            rows: 2,
                        }
                    },

                    height: {
                        type: 'number',
                        uniforms: {
                            label: t`Hauteur`,
                            placeholder: t`pixel`,
                        }
                    },
                }
            },
        },
    }
}
